module.exports = __webpack_public_path__ + "img/771.1393d915.jpg";